import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Ressource } from 'src/app/shared/models/ressource';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddActeursComponent } from '../add-acteurs/add-acteurs.component';
import { Constant } from 'src/app/shared/service/utils/contant';
import { Acteurs } from 'src/app/shared/models/acteurs';
import { EditActeursComponent } from '../edit-acteurs/edit-acteurs.component';

@Component({
  selector: 'app-acteurs',
  standalone: false,
  templateUrl: './acteurs.component.html',
  styleUrl: './acteurs.component.scss'
})

export class ActeursComponent  {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;
  isLoading: boolean = true;

  actionData: any =[];
  validationform: UntypedFormGroup;
  modalRef: NgbModalRef | null = null;

  itemToDelete!: Acteurs; 
  searchTerm: string = '';

  pageSize: number = 10; 

  filteredtems: any = [];
  firstProjets: number = 0; // La page actuelle (commence à 0)
  rowsProjets: number = 10; // Nombre d'éléments par page
  totalRecords: number = 0; // Nombre total d'éléments
  paginatedProjets = [];

  constructor(
      private modalService: NgbModal,
      public formBuilder: UntypedFormBuilder,
      private paramservice:ParameterService,
      private localstorage:LocalStorageService,
      private confirmationService: ConfirmationService,
      private messageService: MessageService,
      private  FecthDataService :FecthDataService,
      private ngxService:NgxUiLoaderService

  ) {
    
    
    this.FecthDataService.actionCreated$.subscribe(() => {
      // Met à jour la liste après la création réussie d'un glossaire
      this.fetchData();
    });   }

  ngOnInit(): void {
  }

   fetchData() {
    
    
    this.paramservice.getacteurs().subscribe(

      (response:any)=>{
        this.isLoading = false
        this.actionData = response.data;
        this.filteredtems = this.actionData;  
        this.totalRecords = this.filteredtems.length;
        this.updatePaginatedProjets(); // Initial pagination
       // console.log("this.actionData",this.actionData);
        
      },
      (error)=>{
       // console.log("une erreur est survenu",error);
        
      }
      
    ) ;
  }
  onPageChangeProjets(event) {
    this.firstProjets =  event.first; // Mise à jour de la page actuelle
    this.rowsProjets =  event.rows ; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }
  
  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredtems.slice(start, end);
  }

  openModal() {
    this.modalService.open(AddActeursComponent, {
       centered: true,
       backdrop: 'static', 
        size:"xl"

       });
  }

  EditModal(action:any) {
    this.localstorage.saveActeur(action)
      const modalRef = this.modalService.open(EditActeursComponent,{
        backdrop: 'static', 
        centered: true,
        size:"xl"

      }, );
  }

  confirm1(event: Event) {
    this.confirmationService.confirm({
        target: event.target as EventTarget,
        message: 'Êtes-vous sûr de vouloir supprimer cet acteur?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        rejectButtonStyleClass: 'p-button-text',
        acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
        rejectLabel: 'Non', // Définir le libellé du bouton "Non"
        accept: () => {
            this.ngxService.start();
            this.paramservice.deleteActeur(event).subscribe(

              (response:any)=>{

               // console.log("la reponse du webserice",response);
                this.messageService.add({ severity: 'succes', summary: Constant.rechercheiTitle, detail: response.message });

                this.fetchData();
                this.ngxService.stop();

              },
              (error)=>{
                this.ngxService.stop();

               // console.log("une erreur est survenu",error);
                this.messageService.add({ severity: 'error', summary: Constant.rechercheiTitle, detail: error });

                
              },
            )
          },
        // reject: () => {
        //     this.messageService.add({ severity: 'warn', summary: Constant.rechercheiTitle, detail: 'Vous avez rejeté', life: 3000 });
        // }
    });
}

fiterActeur() {
  const lowerSearchTerm = this.searchTerm.toLowerCase();
  this.filteredtems = this.actionData.filter((item: any) => {
      // Vérifier que item et ses propriétés existent avant de filtrer
      const matchesNom = item.nom && item.nom.toLowerCase().includes(lowerSearchTerm);
       return matchesNom ;
  });
  this.updatePaginatedProjets();
}


changePageSize() {
  // Met à jour les données filtrées en fonction de la nouvelle taille de page sélectionnée
  this.filteredtems = this.filteredtems.slice(0, this.pageSize);
}

}